import { render, staticRenderFns } from "./Suporte.vue?vue&type=template&id=10a3a363&"
import script from "./Suporte.vue?vue&type=script&lang=ts&"
export * from "./Suporte.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports